import { render, staticRenderFns } from "./GatewayCtrCom.vue?vue&type=template&id=ec640bd4&"
import script from "./GatewayCtrCom.vue?vue&type=script&lang=ts&"
export * from "./GatewayCtrCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports